import React from 'react'
import styles from './survey-answers.module.css'

const TextAnswers = (props) => {
    const { title, question } = props;
    const { name, order, data } = question;

    return (
        <>
            <p className={styles['question-title']}>{order}. {name}</p>
            {data.length ?
                <ul className={styles['text-answers-container']}>
                    {
                        data.map((item) => (
                            <li key={item.id} className={styles['text-answer']}>
                                <p>{item.textValue}</p>
                            </li>
                        ))
                    }
                </ul>
                : <p>N/D</p>
            }
        </>
    )
}

export default TextAnswers